import { useEffect, useState } from 'react';

import { PageTitle } from 'presentation/components/PageTitle';
import { MapView } from 'presentation/components/StreetView';
import { useLocation } from 'react-router-dom';
import { MapInfo } from './models/MapInfo';

const CU05701Page = () => {
    const location = useLocation();

    const [mapInfo, setMapInfo] = useState<MapInfo>();

    useEffect(() => {
        setMapInfo(location.state as MapInfo);
    }, []);

    return (
        <>
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexFlow: 'column',
                    textAlign: 'center',
                }}
                className="CU-002-01-container "
            >
                <section
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        paddingRight: 40,
                    }}
                >
                    <PageTitle title="出品中物件一覧" />
                </section>

                <section
                    style={{
                        height: '100%',
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                    id="map"
                >
                    <MapView
                        containerStyle={{
                            width: '80%',
                            height: '80%',
                        }}
                        center={{
                            lat: mapInfo?.lat ?? 0,
                            lng: mapInfo?.lng ?? 0,
                        }}
                        streetViewVisible={false}
                        zoom={18}
                        {...mapInfo}
                    />
                </section>
            </div>
        </>
    );
};
export default CU05701Page;
